module.exports = __webpack_public_path__ + "static/media/GA.f2442ae0.svg";